export default "__VITE_ASSET__DwYss79L__"